import React, { FC, useCallback } from 'react';
import { HeadingExtension, HeadingExtensionAttributes } from '@remirror/extension-heading';
import { useActive, useCommands } from '@remirror/react-core';
import { CommandButton, CommandButtonProps } from './CommandButton';
import { COLORS } from 'styles/constants';

export interface ToggleHeadingButtonProps extends Omit<CommandButtonProps, 'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'> {
  attrs?: Partial<HeadingExtensionAttributes>;
  commandName?: string;
  onClose?: () => void;
}

export const ToggleHeadingButton: FC<ToggleHeadingButtonProps> = ({ attrs, commandName, onClose, ...rest }) => {
  const { toggleHeading } = useCommands<HeadingExtension>();

  const handleSelect = useCallback(() => {
    onClose && onClose();
    if (toggleHeading.enabled(attrs)) {
      toggleHeading(attrs);
    }
  }, [toggleHeading, attrs]);

  const active = useActive<HeadingExtension>().heading(attrs);
  const enabled = toggleHeading.enabled(attrs);

  return (
    <CommandButton
      {...rest}
      commandName={commandName ? commandName : 'toggleHeading'}
      active={active}
      enabled={enabled}
      attrs={attrs}
      onSelect={handleSelect}
    />
  );
};
